import {
  customScrollMinimal,
  TableCell,
  TableHeader,
  typographyV2,
} from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const TableWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  ${customScrollMinimal}

  table tr {
    cursor: default;
    &:hover {
      td {
        background-color: var(--background-soft);
      }
    }
  }
`;

export const StyledTableHeader = styled(TableHeader)`
  position: sticky;
  left: 0;
  top: 0;
  border-bottom: 1px solid var(--border-default);
  z-index: var(--z-index-header-cell);
  background-color: var(--background-soft);
`;

export const StyledTableCell = styled(TableCell)<{ $isActive?: boolean }>`
  background-color: var(--background-soft);
  ${({ $isActive }) => $isActive && 'background: none;'}
`;

export const StyledTableRow = styled.tr<{
  $isActive?: boolean;
}>`
  &:hover {
    cursor: pointer;
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      background: repeating-linear-gradient(
        -45deg,
        var(--background-soft),
        var(--background-soft) 3px,
        var(--surface-default) 3px,
        var(--surface-default) 5px
      );
    `}
`;

export const ThemeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const FallbackLogo = styled.div<{
  $size: number;
}>`
  cursor: default;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  background-color: var(--kg-theme);
  display: flex;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  color: var(--text-default);
  ${typographyV2.titleSm}
`;
